export const companiesCompanyIdCustomRolesCustomRoleManagementData =
  "/companies/:company_id/custom_roles/custom_role_management_data";
